import React from "react";
import {BaseFragment, BaseFragmentProps, BaseFragmentState} from "../shared/BaseFragment";
import {StyledBoxColumn} from "../shared/StyledComponents";
import {PathComponent} from "../index";
import {Outlet} from "react-router-dom";
import {COLOR_BG1} from "./App";
import {GameFragment} from "./GameFragment";
import {GamesFragment} from "./GamesFragment";

export type MainProps = BaseFragmentProps & {}

type MainState = BaseFragmentState & {}

export class Main extends BaseFragment<MainProps, MainState> {

  static nestedPaths(): PathComponent[] {
    return [
      {
        path: "new",
        render: pathProps => <GamesFragment path={pathProps}/>,
      },
      {
        path: ":room_id",
        render: pathProps => <GameFragment
          path={pathProps}
          roomId={(pathProps.params.room_id as string)?.toUpperCase()}/>,
      },
    ]
  }

  renderContainerContent(): React.ReactElement {
    return <StyledBoxColumn style={{background: COLOR_BG1, flexGrow: 1, gap: 0, position: "relative"}}>
      <img src={"/images/cover2.png"}
           style={{position: "absolute", width: "100%", height: "100%", objectFit: "cover", opacity: 0.2}}/>
      <Outlet/>
    </StyledBoxColumn>
  }
}
